@if (isNotClickable) {
{{ cellValue }}
} @else {
<button (click)="loadContractDetail()" porAddFeature featureName="contract-button-details" class="btn-link" [dynamicValue]="cellValue">
    {{ cellValue }}
</button>
}
